import React from "react";
import { Link } from "gatsby";
import Logo from "images/lucid-modules.svg";
import FbIcon from "images/social-icons/facebook.svg";
import LinkedInIcon from "images/social-icons/linkedin.svg";
import InstagramIcon from "images/social-icons/instagram.svg";
import YtIcon from "images/social-icons/youtube.svg";
import GithubIcon from "images/social-icons/github.svg";

const Footer = () => {
  return (
    <footer>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Blocks */}
        <div className="grid sm:grid-cols-12 lg:grid-cols-10 gap-8 py-8 md:py-12 border-t border-lucid-800">
          {/* 1st block */}
          <div className="sm:col-span-12 lg:col-span-2 lg:max-w-xs">
            <div className="mb-2">
              {/* Logo */}
              <Link className="inline-flex"
                    to="/"
                    aria-label="Lucid Modules Home"
              >
                <Logo />
              </Link>
            </div>
          </div>
          {/* 2nd block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <p className="text-xs text-lucid-200 font-semibold uppercase underline mb-3">Products</p>
            <ul className="text-sm space-y-2">
              <li>
                <a className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                   href="https://pod.lucidmodules.com/"
                >
                  Printify POD Multi User Panel
                </a>
              </li>
              <li>
                <a className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                   href="https://gougou.cash/"
                >
                  Personal Expense Manager
                </a>
              </li>
              <li>
                <Link
                    className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                    to="/promo/magento-2-extensions/checkout-addons/">
                  Checkout Addons for Magento 2
                </Link>
              </li>
              <li>
                <Link
                    className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                    to="/promo/wordpress-plugins/tiqr-authentication/">
                  Biometric WordPress Login
                </Link>
              </li>
            </ul>
          </div>
          {/* 3rd block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <p className="text-xs text-lucid-200 font-semibold uppercase underline mb-3">Resources</p>
            <ul className="text-sm space-y-2">
            <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                   to="/tools/can-i-run-web-ar/"
                >
                  Can I run Web AR
                </Link>
              </li>
              <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                   to="/tools/color-palette-generator/"
                >
                  Color Generator
                </Link>
              </li>
              <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                   to="/tools/url-to-qr-code-generator/"
                >
                  QR Code URL Generator
                </Link>
              </li>
              <li>
                <a className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                   href="https://revolut-tax.lucidmodules.com/"
                >
                  PIT-38 for Revolut
                </a>
              </li>
              <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                      to="/blog"
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          {/* 4th block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <p className="text-xs text-lucid-200 font-semibold uppercase underline mb-3">Company</p>
            <ul className="text-sm space-y-2">
              <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                      to="/about"
                >
                  About us
                </Link>
              </li>
              <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                      to="/magento2-consulting-taipei"
                >
                  Magento 2 in Taipei
                </Link>
              </li>
              <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                      to="/magento2-augmented-reality-and-3d"
                >
                  Magento 2 AR & 3D
                </Link>
              </li>
              <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                      to="/contact"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                      to="/inquiry"
                >
                  Inquiry
                </Link>
              </li>
              <li>
                <a className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                   href="https://store.lucidmodules.com/"
                >
                  Store
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom area */}
        <div className="md:flex md:items-center md:justify-between pb-4 md:pb-8">
          {/* Social links */}
          <ul className="flex mb-4 md:order-1 md:ml-4 md:mb-0">
            <li>
              <a
                className="flex justify-center items-center text-accent-200 hover:text-lucid-300 transition duration-150 ease-in-out"
                href="https://www.facebook.com/LucidModules/"
                aria-label="Facebook"
              >
                <FbIcon className="w-8 h-8" />
              </a>
            </li>
            <li className="ml-2">
              <a
                className="flex justify-center items-center text-accent-200 hover:text-lucid-300 transition duration-150 ease-in-out"
                href="https://instagram.com/lucidmodules"
                aria-label="Instagram"
              >
                <InstagramIcon className="w-8 h-8" />
              </a>
            </li>
            <li className="ml-2">
              <a
                className="flex justify-center items-center text-accent-200 hover:text-lucid-300 transition duration-150 ease-in-out"
                href="https://www.linkedin.com/company/lucid-modules"
                aria-label="Linkedin"
              >
                <LinkedInIcon className="w-8 h-8" />
              </a>
            </li>
            <li className="ml-2">
              <a
                className="flex justify-center items-center text-accent-200 hover:text-lucid-300 transition duration-150 ease-in-out"
                href="https://www.youtube.com/@lucidmodules"
                aria-label="Youtube"
              >
                <YtIcon className="w-8 h-8" />
              </a>
            </li>
            <li className="ml-2">
              <a
                className="flex justify-center items-center text-accent-200 hover:text-lucid-300 transition duration-150 ease-in-out"
                href="https://github.com/LucidModules"
                aria-label="Github"
              >
                <GithubIcon className="w-8 h-8" />
              </a>
            </li>
          </ul>
          {/* Links */}
          <div className="text-sm text-lucid-600">
            <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                  to="/license/"
            >License</Link> · <Link className="text-lucid-300 hover:text-lucid-300 transition duration-150 ease-in-out"
                                    to="/privacy-policy/"
          >Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
